const API_URL = `${process.env.REACT_APP_API_URL}`


const API_ENDPOINTS = {
    LOGIN: `${API_URL}/auth/login`,
    FORGOT_PASSWORD: `${API_URL}/auth/forgot-password`,
    RESET_PASSWORD: `${API_URL}/auth/reset-password`,
    HOME_LAYOUT: `${API_URL}/home-layout`,
    NOTIFICATIONS: `${API_URL}/notifications`,
    ADMIN_USERS: `${API_URL}/adminUsers`,
    ACCOUNT_DELETION: `${API_URL}/deleteAccounts`,
    CUSTOMERS: `${API_URL}/customers`,
    CUSTOMER_ORDERS: `${API_URL}/customers/orders`,
    CATEGORY: `${API_URL}/category`,
    BUSINESS_CATEGORY: `${API_URL}/business-category`,
    LANGUAGES: `${API_URL}/languages`,
    COURSES: `${API_URL}/courses`,
    COLLECTION: `${API_URL}/collections`,
    COLLECTION_COURSES: `${API_URL}/collections/collection-courses`,
    RELATED_COURSES: `${API_URL}/courses/related-courses`,
    CROSS_SELL_COURSES: `${API_URL}/courses/cross-sell-courses`,
    COURSES_SECTION: `${API_URL}/courses/course-section`,
    COURSES_VIDEO: `${API_URL}/courses/course-video`,
    TOP_SEARCH: `${API_URL}/search/top-search`,
    BANNER: `${API_URL}/banner`,
    ORDERS: `${API_URL}/orders`,
    FAQS: `${API_URL}/faqs`,
    TESTIMONIALS: `${API_URL}/testimonials`,
    QUIZ: `${API_URL}/quiz`,
    QUIZ_SECTION: `${API_URL}/quiz/sections`,
    QUIZ_QUESTIONS: `${API_URL}/quiz/questions`,
    QUIZ_SCORES: `${API_URL}/quiz-scores`,
    SECTION_SCORES: `${API_URL}/section-scores`,
    BADGES: `${API_URL}/badges`,
}

export default API_ENDPOINTS